const basePath = "/live/imgs";

export const ChessImgPath1 = `${basePath}/ch_live_1.png`;
export const ChessImgPath2 = `${basePath}/ch_live_2.png`;
export const ChessImgPath3 = `${basePath}/ch_live_3.png`;
export const ChessImgPath4 = `${basePath}/ch_live_4.png`;
export const ChessImgPath5 = `${basePath}/ch_live_5.png`;
export const ChessImgPath6 = `${basePath}/ch_live_6.png`;
export const ChessImgPath7 = `${basePath}/ch_live_7.png`;
export const ChessImgPath8 = `${basePath}/ch_live_8.png`;
export const ChessImgPath9 = `${basePath}/ch_live_9.png`;
export const ChessImgPath10 = `${basePath}/ch_live_10.png`;
export const ChessImgPath11 = `${basePath}/ch_live_11.png`;
export const ChessImgPath12 = `${basePath}/ch_live_12.png`;
export const ChessImgPath13 = `${basePath}/ch_live_13.png`;
export const ChessImgPath14 = `${basePath}/ch_live_14.png`;
export const ChessImgPath15 = `${basePath}/ch_live_15.png`;
export const ChessImgPath16 = `${basePath}/ch_live_16.png`;
export const ChessImgPath17 = `${basePath}/ch_live_17.png`;
export const ChessImgPath18 = `${basePath}/ch_live_18.png`;
export const ChessImgPath19 = `${basePath}/ch_live_19.png`;
export const ChessImgPath20 = `${basePath}/ch_live_20.png`;
export const ChessImgPath21 = `${basePath}/ch_live_21.png`;
export const ChessImgPath22 = `${basePath}/ch_live_22.png`;
export const ChessImgPath23 = `${basePath}/ch_live_23.png`;
export const ChessImgPath24 = `${basePath}/ch_live_24.png`;
export const FootballPitchImgPath = `${basePath}/football_pitch.png`;
export const LinePitchImgPath = `${basePath}/picture_line.png`;
export const LivePitchImgPath = `${basePath}/picture_live.png`;